module.exports = __webpack_public_path__ + "img/mourning-1.1be1958a.jpg";